import { gql } from "@apollo/client";

export const GET_ACTIVE_FROGDIAGRAMS = gql`
  query getActiveFrogDiagrams{
    getActiveFrogDiagrams
  }
`;
